import React from 'react';
import { Text, View, SafeAreaView, ScrollView } from 'react-native';

import { t } from 'Locale';
import { Button, Hr, Icon, ModalHeader } from 'LocalGluons';
import defaultStyles from './PreConsentScene.jss';

interface PreConsentSceneProps {
    close: () => void;
    onContinue: () => void;
}

const PreConsentScene = ({ close, onContinue }: PreConsentSceneProps): React.ReactElement => (
    <SafeAreaView style={defaultStyles.container}>
        <ModalHeader
            style={{
                iconContainer: defaultStyles.iconCloseContainer
            }}
            onPress={close}
        />
        <ScrollView contentContainerStyle={defaultStyles.scrollContainer}>
            <View style={defaultStyles.logoBox}>
                <Icon style={defaultStyles.logo} name="voyo_logo" />
            </View>

            <Text style={defaultStyles.title}>
                {t('PARTNER.VOYO.PACKAGE1_TRIAL_INFO_TITLE_MOBILES')}
            </Text>
            <Hr style={defaultStyles.hrStyle} />
            <Text style={defaultStyles.subtitle}>
                {t('PARTNER.VOYO.PACKAGE1_TRIAL_INFO_DESCRIPTION_MOBILES')}
            </Text>

            <View style={defaultStyles.buttonContainer}>
                <Button
                    style={{
                        button: defaultStyles.buttonContinue,
                        text: defaultStyles.textContinue
                    }}
                    title={t('PARTNER.VOYO.CONTINUE_BTN_MOBILES')}
                    onPress={onContinue}
                />
                <Button
                    onPress={close}
                    style={{ button: defaultStyles.button }}
                    title={t('PARTNER.VOYO.CLOSE_BTN')}
                    isSecondary
                />
            </View>
        </ScrollView>
    </SafeAreaView>
);

export default PreConsentScene;
